module.exports = __webpack_public_path__ + "img/may_320.4561c82d.png";